import { Text } from '@dixa/lib-shared-habla';

export function RoutedThroughTag(): JSX.Element {
  /**
   * TODO: Fetch array of human readable tag names and display them. But do this
   * when an api is available. See
   * https://dixa-product.atlassian.net/browse/AX-1147
   */
  return (
    <Text.Paragraph>Tag · Automation visited the tag node.</Text.Paragraph>
  );
}
